'use client'

import { memo, type PropsWithChildren, useMemo } from 'react'

import { useAppDispatch, useAppSelector } from '@/redux/hooks'

import { TypeOfAnimal, useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'
import { setSubCategory } from '@/redux/features/catalogSlice'
import { useParams, useRouter } from 'next/navigation'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

export const FilterWrapper = memo(function FilterWrapper({ children }: PropsWithChildren) {
    const dispatch = useAppDispatch()
    const navigate = useRouter()
    const params = useParams()
    const { t } = useTranslation()

    const { animalType } = useAppSelector(state => state.filter)
    const { subCategory } = useAppSelector(state => state.catalogv1)

    const { data: animalTypes } = useGetInitialCategoriesQuery()

    const currentCategory = useMemo(() => {
        const paramsCategory = params?.catalog?.[0]

        if (paramsCategory && animalTypes) return animalTypes.find(c => c.translit === paramsCategory)
    }, [params?.catalog, animalTypes])

    const handleCategoryClick = (item: TypeOfAnimal | undefined) => {
        if (!item) dispatch(setSubCategory(null))
        else navigate.push(`/catalog/${item.translit}`)
    }

    const handleSubCategoryClick = (item: TypeOfAnimal) => {
        dispatch(setSubCategory(item))
    }

    const backToAllSpecialities = () => {
        const animalType = params?.catalog?.[1]

        if (animalType) {
            navigate.push(`/catalog/${animalType}`)
        } else navigate.push('/catalog')

        dispatch(setSubCategory(null))
    }

    return (
        <div className='catalog__sorts'>
            <div className='catalog__sort-content'>
                <p className='catalog__sort-title'>{t('specializations')}</p>
                <ul
                    className='catalog__sort-links'
                    style={{ whiteSpace: 'nowrap' }}
                >
                    <li
                        onClick={backToAllSpecialities}
                        className={`catalog__sort-link ${!animalType.length && 'catalog__sort-link_blue'}`}
                    >
                        {animalType.length ? (
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                    stroke='#A9B4D1'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        ) : null}
                        {t('allSpecializations')}
                    </li>

                    {currentCategory ? (
                        <>
                            <li
                                onClick={() => handleCategoryClick(undefined)}
                                className={`catalog__sort-link ${!subCategory && 'catalog__sort-link_blue'}`}
                            >
                                {subCategory && (
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M12 6L8.05905 10.4336C8.02538 10.4715 8.02538 10.5285 8.05905 10.5664L12 15'
                                            stroke='#A9B4D1'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                        />
                                    </svg>
                                )}
                                {currentCategory.title}
                                {/* {animalCategories?.find(item => item.id === animalType[0])?.title} */}
                            </li>
                            {currentCategory?.animal_types_category?.map(item => (
                                <li
                                    onClick={() => handleSubCategoryClick(item as unknown as TypeOfAnimal)}
                                    className={classNames(
                                        'catalog__sort-link',
                                        subCategory?.id === item.id && ' catalog__sort-link_blue'
                                    )}
                                    key={item.id}
                                >
                                    {item.title}
                                </li>
                            ))}
                        </>
                    ) : (
                        animalTypes?.map(item => (
                            <li
                                onClick={() => handleCategoryClick(item)}
                                className={classNames(
                                    'catalog__sort-link',
                                    params?.catalog?.[0] === item.translit && ' catalog__sort-link_blue'
                                )}
                                key={item.id}
                            >
                                {item.title}
                            </li>
                        ))
                    )}
                </ul>
                <ul className='catalog__sort-list'>{children}</ul>
            </div>
        </div>
    )
})
